import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { SingleBillPayload } from '@ctct/infrastructure-layer';
import { bpConsoleApi } from '@ctct/infrastructure-layer';

import { useMutationMemoized } from '../helpers/useMutationMemoized';
import { QueryKeys } from '../queries/constants';

export const useUpdateSingleBill = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (body: SingleBillPayload) => bpConsoleApi.putSingleBill(body),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [QueryKeys.SINGLE_BILL] }),
        queryClient.invalidateQueries({ queryKey: [QueryKeys.SINGLE_BILL_SETUP_ELEMENT] }),
      ]);
    },
  });

  return useMutationMemoized(mutation);
};

export type UpdateSingleBillMutation = ReturnType<typeof useUpdateSingleBill>;

export type UpdateSingleBillPayload = SingleBillPayload;
